export default __webpack_public_path__ + "static/media/ImageFour.a18708fb.jpg";